import { RmPageHeader as CoreRmPageHeader, type RmPageHeaderProps as CoreRmPageHeaderProps } from "randmarcomps";
import type { ReactNode } from "react";
import DataRefreshAssistantCluster, {
  type DataRefreshAssistantClusterProps,
} from "./DataRefreshAssistantCluster";

export type RmPageHeaderProps = Omit<CoreRmPageHeaderProps, "rightTopActions" | "rightBottomActions" | "secondaryRow"> & {
  rightTopActions?: ReactNode;
  rightBottomActions?: ReactNode;
  secondaryRow?: ReactNode;
  dataRefreshAssistant?: DataRefreshAssistantClusterProps;
  pageActions?: ReactNode;
  subHeader?: ReactNode;
};

export default function RmPageHeader({
  rightTopActions,
  rightBottomActions,
  secondaryRow,
  dataRefreshAssistant,
  pageActions,
  subHeader,
  className,
  ...props
}: RmPageHeaderProps) {
  return (
    <CoreRmPageHeader
      {...props}
      className={[className].filter(Boolean).join(" ")}
      rightTopActions={
        dataRefreshAssistant ? <DataRefreshAssistantCluster {...dataRefreshAssistant} /> : rightTopActions
      }
      rightBottomActions={pageActions ?? rightBottomActions}
      secondaryRow={subHeader ?? secondaryRow}
    />
  );
}
